import { render, staticRenderFns } from "./ExchangeReceivablesTable.vue?vue&type=template&id=39d1fd71&scoped=true&"
import script from "./ExchangeReceivablesTable.vue?vue&type=script&lang=js&"
export * from "./ExchangeReceivablesTable.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeReceivablesTable.vue?vue&type=style&index=0&id=39d1fd71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d1fd71",
  null
  
)

export default component.exports